module.exports = __webpack_public_path__ + "img/header-diamondJewelryRosegold@2x.b8f6ddc.webp";